module.exports = {
  DEBIT: 'debit',
  CREDIT: 'credit',
  RECEIPT: 'receipt',
  SELF: 'self',
};
